var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.921509,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#004087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2165 22.0148C17.8777 22.0148 20.9735 17.3248 20.9735 13.2581C20.9735 13.1248 20.9706 12.9922 20.9646 12.8602C21.5669 12.4243 22.0868 11.8846 22.5 11.2664C21.9385 11.5159 21.3427 11.6797 20.7325 11.7522C21.3751 11.3675 21.856 10.7625 22.086 10.0498C21.4818 10.4082 20.8209 10.6609 20.1317 10.7971C19.6677 10.3043 19.0543 9.97796 18.3863 9.86867C17.7183 9.75937 17.0329 9.87317 16.436 10.1925C15.8391 10.5117 15.3641 11.0187 15.0843 11.6351C14.8044 12.2514 14.7354 12.9428 14.8879 13.6023C13.6643 13.5412 12.4672 13.2236 11.3743 12.6699C10.2814 12.1163 9.31713 11.3391 8.54404 10.3887C8.14985 11.0664 8.02896 11.8689 8.20601 12.6327C8.38306 13.3965 8.84474 14.0639 9.49691 14.4991C9.00805 14.4841 8.52993 14.352 8.10274 14.1138C8.10274 14.1269 8.10274 14.1396 8.10274 14.1534C8.1037 14.8635 8.35008 15.5514 8.80015 16.1007C9.25022 16.6499 9.8763 17.0266 10.5723 17.1671C10.1193 17.2909 9.6438 17.3089 9.18265 17.2198C9.37921 17.8311 9.76187 18.3657 10.2772 18.7489C10.7924 19.132 11.4146 19.3446 12.0566 19.3568C10.9664 20.2125 9.62012 20.6766 8.23427 20.6744C7.98889 20.6746 7.74371 20.6604 7.5 20.6318C8.90721 21.536 10.545 22.016 12.2176 22.0144",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7d821f3e013b03333abfa00a6f2b1c9b.svg";
export { ForwardRef as ReactComponent };